export default __webpack_public_path__ + "static/media/zalo_image.e2db26c3.svg";